var map = {
	"./logo_chatdesk.svg": 208,
	"./logo_customerio.svg": 508,
	"./logo_facebook.svg": 266,
	"./logo_freshdesk.svg": 337,
	"./logo_frontapp.svg": 338,
	"./logo_gladly.svg": 339,
	"./logo_gorgias.svg": 340,
	"./logo_helpscout.svg": 341,
	"./logo_instagram.svg": 267,
	"./logo_kustomer.svg": 342,
	"./logo_salesforce.svg": 509,
	"./logo_shopify.svg": 268,
	"./logo_tiktok.svg": 269,
	"./logo_tiktokads.svg": 510,
	"./logo_trustpilot.svg": 511,
	"./logo_twitter.svg": 343,
	"./logo_whistle.svg": 344,
	"./logo_youtube.svg": 512,
	"./logo_zendesk.svg": 209
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2090;